export default defineNuxtRouteMiddleware(() => {
	const routeUrl = useRouteUrl()
	const userStore = useUserStore()
	if (!userStore.token || userStore.user?.status != "enable") {
		return navigateTo(routeUrl.AuthStartUrl())
	}
})
